/**
 * Per-cause and per-category activity examples used in the City×Cause /
 * City×Category combo intro. Keyed by the URL slug. These short example
 * lists differentiate every combo intro from every other so the page is
 * not interchangeable templated content — see editorial review note in
 * /app/memory/PRD.md ("interchangeable-content risk on combo intros").
 *
 * Phrasing rules:
 *  - Concrete, neutral examples of typical activity types
 *  - No medical / tax / legal / political claims
 *  - No invented statistics
 *  - No "verified" / "trusted" / "guaranteed" wording
 *  - 8–18 words per entry; reads as a natural list inside one sentence
 */
export const TAG_EXAMPLES = {
  // ---- Causes (slug-keyed) -----------------------------------------------
  "climate-and-environment":
    "community clean-ups, urban gardening, repair initiatives, sustainability education and local environmental projects",
  "education":
    "school tutoring, mentoring, language classes, homework help and adult learning programmes",
  "mental-health":
    "peer-support groups, helplines, accompaniment programmes and awareness initiatives",
  "refugees-and-migration":
    "language classes, accompaniment to appointments, homework help, integration mentoring and donation drives",
  "poverty-and-hunger":
    "food rescue, soup-kitchen and distribution shifts, household support and emergency relief",
  "health-and-wellbeing":
    "patient companionship, hospice support, community wellbeing programmes and awareness work",
  "animal-welfare":
    "shelter shifts, animal fostering, rescue support and wildlife protection work",
  "human-rights":
    "advocacy campaigns, legal-support volunteering, awareness work and accompaniment programmes",
  "arts-and-culture":
    "community arts, museum and theatre programmes, cultural education and youth creative projects",
  "technology-for-good":
    "tech mentoring, civic-tech projects, data-for-good initiatives and digital-inclusion work",

  // ---- Categories (slug-keyed) -------------------------------------------
  "donate":
    "one-off and recurring donations to current organisation campaigns",
  "volunteer":
    "hands-on volunteer shifts, weekly commitments, one-off events and seasonal pushes",
  "fundraise":
    "current fundraising campaigns you can back, or run yourself for a chosen organisation",
  "pro-bono":
    "pro-bono professional time — legal, design, translation, technical and communications support",
  "invest":
    "impact-investment opportunities from social-purpose organisations and funds",
};

/**
 * Look up an example string for the page's axis_slug (cause slug or
 * category slug). Falls back to a neutral generic when the slug is
 * unknown — never throws.
 */
export function getTagExamples(slug) {
  return (
    TAG_EXAMPLES[String(slug || "").toLowerCase()] ||
    "hands-on volunteering, donation campaigns, fundraising and skills-based pro-bono work"
  );
}
